<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_ order">保费试算</div>
          <div class="cutleft_ policy">险种信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item" style="justify-content: flex-start">
              <label>保障期间</label>
              <div class="pre-box" style="margin-left: 10px">
                <div class="">
                  <a-radio-group
                    :disabled="disabledAll"
                    v-model="guapre"
                    @change="(e) => changeData(e.target.value, 'BZQJa')"
                  >
                    <a-radio
                      v-for="item in guarantPre"
                      :key="item.key"
                      :value="item.key"
                      >{{ item.value }}</a-radio
                    >
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="order">
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
              <!-- <a href="/files/GYBTY/广燕保团意2021版-职业类别表.xls" download=""
                >职业类别表</a
              > -->
              <span class="waring-color" style="margin-left: 20px"
                ><a-icon
                  type="info-circle"
                />&nbsp;不同职业类别需拆单投保，且需投保同一方案</span
              >
            </div>
            <div class="form_item order">
              <label>投保职业</label>
              <div class="right_">
                <div
                  class="check_item s_input"
                  v-for="item in occupationNumberList"
                  :key="item.occupationKind"
                >
                  <label for>
                    {{ item.occupationKind }}
                  </label>
                  <a-input-number
                    :min="0"
                    :disabled="leibie != item.occupationKind||disabledAll"
                    v-model="item.personNum"
                    @change="(value) => changeData(value, 'TBZYa')"
                  ></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
            <div class="form_item" style="justify-content: start">
              <label>投保人行业类型</label>
              <div class="right_">
                <a-select
                  :disabled="disabledAll"
                  placeholder="请选择行业类型"
                  style="width: 280px"
                  class="select_"
                  v-model="countData.HYLX"
                  @change="(value) => changeData(value, 'HYLX')"
                >
                  <a-select-option
                    v-for="item in HYLXOptions"
                    :key="item.value + 'HYLX'"
                    :value="item.value"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </div>
            </div>
            <!-- <div class="form_items">
              <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
              <div class="right_">
                <div class="check_item" style="margin-left: 40px">
                  <a-radio-group
                    name="radioGroup"
                    :default-value="0"
                    :disabled="countData.HYLX != 1 || disabledAll"
                    v-model="countData.SFSGa"
                    @change="(e) => changeData(e.target.value, 'SFSGa')"
                  >
                    <a-radio :value="2">不涉高</a-radio>
                    <a-radio :value="1">涉高</a-radio>
                  </a-radio-group>
                </div>
                <span class="waring-color"><a-icon type="info-circle" />&nbsp;涉高仅限建筑行业投保</span>
              </div>
            </div> -->
            <div class="form_item order">
              <a-form-item :label-col="{ span: 7 }" label="投保人名称">
                <a-input
                  :disabled="disabledAll"
                  style="width: 280px"
                  v-model="countData.name"
                  @change="(e) => changeData(e.target.value, 'name')"
                  placeholder="请填写投保人名称"
                  v-decorator="[
                    'countData.name',
                    {
                      rules: [{ required: true, message: '请输入投保人名称' }],
                    },
                  ]"
                ></a-input>
              </a-form-item>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ order">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">主险</p>
        <!-- 意外伤害身故、残疾 -->
        <div class="form_item">
          <label>意外伤害身故、残疾</label>
          <div class="right_">
            <a-select
              :disabled="disabledAll"
              placeholder="请选择"
              style="width: 300px"
              class="select_"
              @change="(value) => changeData(value, 'SWCJ')"
              v-model="countData.SWCJ"
            >
              <a-select-option
                v-for="item in SWCJOptions"
                :key="item.value + 'SWCJ'"
                :value="item.value"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外伤害医疗费用 -->
          <div class="form_item">
            <label>意外伤害医疗费用（社保范围内100元免赔100%赔付）</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.YLFY"
                @change="(value) => changeData(value, 'YLFY')"
              >
                <a-select-option
                  v-for="(item, index) in YLFYOptions"
                  :key="item.value + 'YLFY' + index"
                  :value="item.value"
                  :disabled="item.disabled"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 自费药费用(即保司系统自费药)（含甲乙丙类自付和自费） -->
          <div class="form_item">
            <label>自费药费用（0免赔50%赔付）</label>
            <div class="right_">
              <a-select
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                :disabled="countData.YLFY === 0 || disabledAll"
                v-model="countData.ZFYF"
                @change="(value) => changeData(value, 'ZFYF')"
              >
                <a-select-option
                  v-for="(item, index) in ZFYFOptions"
                  :key="item.value + 'ZFYF' + index"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 意外住院津贴责任 -->
          <div class="form_item">
            <label>意外住院津贴</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.ZYJT"
                @change="(value) => changeData(value, 'ZYJT')"
              >
                <a-select-option
                  v-for="item in ZYJTOptions"
                  :key="item.value + 'ZYJT'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!--扩展残疾鉴定国家工伤标准 -->
          <div class="form_item ">
            <label>扩展残疾鉴定国家工伤标准</label>
            <div class="right_ gsdiposition">
              <a-select
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                :disabled="nameFilter || disabledAll || countData.HYLX==1"
                v-model="countData.KZSC"
                @change="(value) => changeData(value, 'KZSC')"
              >
                <a-select-option
                  v-for="item in KZSCOptions"
                  :key="item.value + 'KZSC'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
              <div class="gsdc-text waring-color"><a-icon type="info-circle" class="gsdc-icon" />包含家具、木材、五金、金属、建筑、工程、实业、劳务、剪切、车床的企业，不支持扩展工伤评残！</div>
            </div>
          </div>
          <!-- 飞机意外伤害身故和残疾 -->
          <div class="form_item" v-if="this.$route.query.p != 'MP18000963'">
            <label>飞机意外伤害身故和残疾</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.YCXSCa"
                @change="(value) => changeData(value, 'YCXSCa')"
              >
                <a-select-option
                  v-for="item in oneSCOptions"
                  :key="item.value + 'YCXSCa'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 火车意外伤害身故和残疾 -->
          <div class="form_item"  v-if="this.$route.query.p != 'MP18000963'">
            <label>火车意外伤害身故和残疾</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.SHHLa"
                @change="(value) => changeData(value, 'SHHLa')"
              >
                <a-select-option
                  v-for="item in SHHLOptions"
                  :key="item.value + 'SHHLa'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 轮船意外伤害身故和残疾 -->
          <div class="form_item"  v-if="this.$route.query.p != 'MP18000963'">
            <label>轮船意外伤害身故和残疾</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.KYLCYW"
                @change="(value) => changeData(value, 'KYLCYW')"
              >
                <a-select-option
                  v-for="item in KYLCYWOptions"
                  :key="item.value + 'KYLCYW'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 汽车意外伤害身故和残疾 -->
          <div class="form_item"  v-if="this.$route.query.p != 'MP18000963'">
            <label>汽车意外伤害身故和残疾</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.KYQCYW"
                @change="(value) => changeData(value, 'KYQCYW')"
              >
                <a-select-option
                  v-for="item in KYQCYWOptions"
                  :key="item.value + 'KYQCYW'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 驾乘意外伤害身故和残疾 -->
          <div class="form_item"  v-if="this.$route.query.p != 'MP18000963'">
            <label>驾乘意外伤害身故和残疾</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.JCYW"
                @change="(value) => changeData(value, 'JCYW')"
              >
                <a-select-option
                  v-for="item in JCYWOptions"
                  :key="item.value + 'JCYW'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- 猝死 -->
          <div class="form_item">
            <label>猝死</label>
            <div class="right_">
              <a-select
                :disabled="disabledAll"
                placeholder="请选择"
                style="width: 300px"
                class="select_"
                v-model="countData.WGFY"
                @change="(value) => changeData(value, 'WGFY')"
              >
                <a-select-option
                  v-for="item in WGFYOptions"
                  :key="item.value + 'WGFY'"
                  :value="item.value"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </div>
          </div>
          <!-- <div style="color: #fe8f2d; margin: 15px 0">
            本保单默认附加境内公出附加险条款、就餐时间扩展条款、上下班途中条款
          </div> -->
        </div>
        <div class="btn_list">
         <a-button style="margin-bottom:50px;" class="calBtn_" type="primary" @click="goplicy" v-if='!agreementRead'>
          完成报价，立即投保</a-button>
          <a-button
            class="calBtn_"
            :disabled="disabledAll"
            type="primary"
            @click="countPremiumSum"
            >刷新试算</a-button
          >
          <!-- <a-button class="calBtn_" :disabled="disabledAll" type="primary">
            <a href="/files/GYBTY/广燕保自选团意2021版-速算报价书.xls" download=""
              >速算报价</a
            >
          </a-button> -->
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>

import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      leibie: 1,
      productCode: "",
      plan: "",
      form: this.$form.createForm(this, { name: "advanced_search" }),
      guapre: 3,
      //保障期间
      guarantPre: [
        // {
        //   key: 1,
        //   value: "1个月",
        // },
        {
          key: 3,
          value: "3个月",
        },
        {
          key: 6,
          value: "6个月",
        },
        {
          key: 12,
          value: "12个月",
        },
      ],

      premiumSum: 0, //总保费
      // 扩展残疾鉴定国家工伤标准
      KZSCOptions: [
        {
          value: 0,
          name: "不附加",
        },
        {
          value: 1,
          name: "附加",
        },
      ],
      // 猝死
      WGFYOptions: [
        {
          value: 0,
          name: "不附加",
        },
        {
          value: 100000,
          name: "10万",
        },
      ],
      // 飞机意外伤害身故和残疾
      oneSCOptions: [
        {
          value: 0,
          name: "0",
        },
        {
          value: 100000,
          name: "10万",
        },
        {
          value: 200000,
          name: "20万",
        },
        {
          value: 300000,
          name: "30万",
        },
        {
          value: 400000,
          name: "40万",
        },
        {
          value: 500000,
          name: "50万",
        },
        {
          value: 600000,
          name: "60万",
        },
        {
          value: 700000,
          name: "70万",
        },
        {
          value: 800000,
          name: "80万",
        },
        {
          value: 900000,
          name: "90万",
        },
        {
          value: 1000000,
          name: "100万",
        },
      ],
      // 火车意外伤害身故和残疾
      SHHLOptions: [
        {
          value: 0,
          name: "0",
        },
        {
          value: 100000,
          name: "10万",
        },
        {
          value: 200000,
          name: "20万",
        },
        {
          value: 300000,
          name: "30万",
        },
        {
          value: 400000,
          name: "40万",
        },
        {
          value: 500000,
          name: "50万",
        },
        {
          value: 600000,
          name: "60万",
        },
        {
          value: 700000,
          name: "70万",
        },
        {
          value: 800000,
          name: "80万",
        },
        {
          value: 900000,
          name: "90万",
        },
        {
          value: 1000000,
          name: "100万",
        },
      ],
      //轮船意外伤害身故和残疾
      KYLCYWOptions: [
        {
          value: 0,
          name: "0",
        },
        {
          value: 100000,
          name: "10万",
        },
        {
          value: 200000,
          name: "20万",
        },
        {
          value: 300000,
          name: "30万",
        },
        {
          value: 400000,
          name: "40万",
        },
        {
          value: 500000,
          name: "50万",
        },
        {
          value: 600000,
          name: "60万",
        },
        {
          value: 700000,
          name: "70万",
        },
        {
          value: 800000,
          name: "80万",
        },
        {
          value: 900000,
          name: "90万",
        },
        {
          value: 1000000,
          name: "100万",
        },
      ],
      //汽车意外伤害身故和残疾
      KYQCYWOptions: [
        {
          value: 0,
          name: "0",
        },
        {
          value: 100000,
          name: "10万",
        },
        {
          value: 200000,
          name: "20万",
        },
        {
          value: 300000,
          name: "30万",
        },
        {
          value: 400000,
          name: "40万",
        },
        {
          value: 500000,
          name: "50万",
        },
      ],
      //驾乘意外
      JCYWOptions: [
        {
          value: 0,
          name: "0",
        },
        {
          value: 50000,
          name: "5万",
        },
        {
          value: 100000,
          name: "10万",
        },
        {
          value: 150000,
          name: "15万",
        },
        {
          value: 200000,
          name: "20万",
        },
        {
          value: 250000,
          name: "25万",
        },
        {
          value: 300000,
          name: "30万",
        },
        {
          value: 350000,
          name: "35万",
        },
        {
          value: 400000,
          name: "40万",
        },
        {
          value: 450000,
          name: "45万",
        },
        {
          value: 500000,
          name: "50万",
        },
      ],
      HYLXOptions: [
        {
          value: 0,
          name: "其他行业",
        },
        // {
        //   value: 1,
        //   name: "建筑行业",
        // },
      ], //是否是建筑行业
      // 测算要提交的数据
      countData: {
        BZQJa: 3, //保障期间?
        TBZYa: 0, //投保职业?
        SFSGa: 2, //是否涉高
        HYLX: 0, //是否是建筑行业
        name: "", //投保人名称
        SWCJ: 100000, //意外伤害身故、残疾
        YLFY: 0, //意外医疗费用
        ZFYF: 0, //自费药费用
        ZYJT: 0, //意外住院津贴
        KZSC: 0, //扩展残疾鉴定国家工伤标准
        YCXSCa: 0, //飞机意外伤害身故和残疾
        SHHLa: 0, //火车意外伤害身故和残疾
        KYLCYW: 0, //轮船意外伤害身故和残疾
        KYQCYW: 0, //汽车意外伤害身故和残疾
        JCYW: 0, //驾乘意外伤害身故和残疾
        WGFY: 0, //猝死
      },
      //提交data
      data: {
        architecture: 0, //是否是建筑行业
        riskInfos: [],
        salPolicy: {
          productCode: "", //产品code
          bracket: 1, //保费期限
          planCode: "",
        },
        salPolicyExt:{
          isworkheightinvolved:2,
          architecture:0
        },
        salPolicyHolder: {
          addfifty: "1", // 测算类型
          stature: 2, //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [], //人数
      },
      planType: "A",
      occupationNumberList: [
        {
          occupationKind: "1类",
          personNum: 0,
        },
        {
          occupationKind: "2类",
          personNum: 0,
        },
        {
          occupationKind: "3类",
          personNum: 0,
        },
        {
          occupationKind: "4类",
          personNum: 0,
        },
        {
          occupationKind: "5类",
          personNum: 0,
        },
      ],
    };
  },
  computed: {
    // 意外伤害身故、残疾
    SWCJOptions() {
      let Options = [
        {
          value: 100000,
          name: "10万",
        },
        {
          value: 200000,
          name: "20万",
        },
        {
          value: 300000,
          name: "30万",
        },
        {
          value: 400000,
          name: "40万",
        },
        {
          value: 500000,
          name: "50万",
        },
        {
          value: 600000,
          name: "60万",
        },
        {
          value: 700000,
          name: "70万",
        },
        {
          value: 800000,
          name: "80万",
        },
        {
          value: 900000,
          name: "90万",
        },
        {
          value: 1000000,
          name: "100万",
        },
      ];
      if (this.leibie=='4类') {
        return Options.filter((item) => item.value <= 600000);
      }
      if (this.leibie=='5类') {
        return Options.filter((item) => item.value <= 500000);
      }
      return Options
    },
    // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
    ZFYFOptions() {
      let Options = [
        //自费药费用(即保司系统自费药)选择框
        {
          value: 0,
          name: "不附加",
        },
        {
          value: 0.1,
          name: "工伤事故医疗费用保额的10%",
        },
        {
          value: 0.2,
          name: "工伤事故医疗费用保额的20%",
        },
      ];
      return Options;
    },
    // 意外伤害医疗费用
    YLFYOptions() {
      let option = [
        {
          value: 0,
          name: "不附加",
          disabled: false,
        },
        {
          value: 10000,
          name: "1万",
          disabled: false,
        },
        {
          value: 20000,
          name: "2万",
          disabled: false,
        },
        {
          value: 30000,
          name: "3万",
          disabled: false,
        },
        {
          value: 40000,
          name: "4万",
          disabled: false,
        },
        {
          value: 50000,
          name: "5万",
          disabled: false,
        },
        {
          value: 60000,
          name: "6万",
          disabled: false,
        },
        {
          value: 70000,
          name: "7万",
          disabled: false,
        },
        {
          value: 80000,
          name: "8万",
          disabled: false,
        },
        {
          value: 90000,
          name: "9万",
          disabled: false,
        },
        {
          value: 100000,
          name: "10万",
          disabled: false,
        },
      ];
      if (this.leibie=='4类') {
        return option.filter((item) => item.value <= 60000);
      }
      if (this.leibie=='5类') {
        return option.filter((item) => item.value <= 50000);
      }
      return option
    },
    // 意外住院津贴
    ZYJTOptions() {
      let ZYJTOptions = [
        //意外住院津贴责任 : ZYJT
        {
          value: 0,
          name: "不附加",
        },
        {
          value: 50,
          name: "50元/天",
        },
        {
          value: 100,
          name: "100元/天",
        },
        {
          value: 150,
          name: "150元/天",
        },
        {
          value: 200,
          name: "200元/天",
        },
      ];
      if(this.countData.SFSGa == 1){
        return ZYJTOptions.filter((item) => item.value <= 100);
      }else{
        if (this.leibie=='5类') {
          return ZYJTOptions.filter((item) => item.value <= 100);
        }else{
          return ZYJTOptions
        }
      }
    },
    // 选的总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach((e) => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let arr = []
      let infos = [
        {
          riskCode: "PL1800143", //意外伤害身故、残疾
          amount: this.countData.SWCJ,
          dutyCode: "CV63001",
          riskInfoName: "disabilityByAccident",
          premiumAmt:0,
          riskName:`意外伤害身故、残疾`,
          riskAmountDesc:this.countData.SWCJ
        },
       
        {
          riskCode: "PL180J136", //自费药费用
          amount: this.countData.ZFYF * this.countData.YLFY,
          dutyCode: "CVJA046",
          riskInfoName: "fullCostMedicine",
          premiumAmt:0,
          riskName:`自费药费用`,
          riskAmountDesc:this.countData.ZFYF * this.countData.YLFY
        },
        {
          riskCode: "selTag99", //扩展残疾鉴定国家工伤标准
          amount: this.countData.KZSC,
          dutyCode: "selTag99",
          riskInfoName: "disabilityAssessment",
          premiumAmt:0,
          riskName:`扩展残疾鉴定国家工伤标准`,
          riskAmountDesc:this.countData.KZSC?'按国家工伤与职业病标准':0
        },
        {
          riskCode: "PL1800144", //飞机意外伤害身故和残疾
          amount: this.countData.YCXSCa,
          dutyCode: "CV01659",
          riskInfoName: "accidentDisabilityByPlane",
          premiumAmt:0,
          riskName:`飞机意外伤害身故和残疾`,
          riskAmountDesc:this.countData.YCXSCa
        },
        {
          riskCode: "PL1800144", //火车意外伤害身故和残疾
          amount: this.countData.SHHLa,
          dutyCode: "CV01660",
          riskInfoName: "accidentDisabilityByTrain",
          premiumAmt:0,
          riskName:`火车意外伤害身故和残疾`,
          riskAmountDesc:this.countData.SHHLa
        },
        {
          riskCode: "PL1800144", //轮船意外伤害身故和残疾
          amount: this.countData.KYLCYW,
          dutyCode: "CV01661",
          riskInfoName: "accidentDisabilityByShip",
          premiumAmt:0,
          riskName:`轮船意外伤害身故和残疾`,
          riskAmountDesc:this.countData.KYLCYW
        },
        {
          riskCode: "PL1800144", //汽车意外伤害身故和残疾
          amount: this.countData.KYQCYW,
          dutyCode: "CV01662",
          riskInfoName: "accidentDisabilityByCar",
          premiumAmt:0,
          riskName:`汽车意外伤害身故和残疾`,
          riskAmountDesc:this.countData.KYQCYW
        },
        {
          riskCode: "PL1800276", //驾乘意外
          amount: this.countData.JCYW,
          dutyCode: "CV01360",
          riskInfoName: "accidentDisabilityByDriver",
          premiumAmt:0,
          riskName:`交通出行意外`,
          riskAmountDesc:this.countData.JCYW
        },
        {
          riskCode: "PL180J105", //猝死
          amount: this.countData.WGFY,
          dutyCode: "CVJB009",
          riskInfoName: "suddenDeath",
          premiumAmt:0,
          riskName:`猝死`,
          riskAmountDesc:this.countData.WGFY
        }
      ];
      if(this.$route.query.p == 'MP18000963'){
          arr =[{
          riskCode: "PL1800181", //意外伤害医疗
          amount: this.countData.YLFY,
          dutyCode: "CVJA017",
          riskInfoName: "hospitalizationByAccident",
          premiumAmt:0,
          riskName:`平安产险附加意外伤害医疗保险（互联网版）`,
          riskAmountDesc:this.countData.YLFY
        },
        {
          riskCode: "PL1800192", //意外伤害住院津贴
          amount: this.countData.ZYJT * 180,
          dutyCode: "CVJD006",
          riskInfoName: "allowanceByAccident",
          premiumAmt:0,
          riskName:`平安产险附加意外伤害住院津贴保险（互联网版）`,
          riskAmountDesc:this.countData.ZYJT+'元/天'
        },
        {
          riskCode: "PL1800259", //甲乙类传染病保险金
          amount: this.countData.SWCJ/10*2 + 100000,
          dutyCode: "CVJB005",
          riskInfoName: "InfectiousDiseases",
          premiumAmt:0,
          riskName:`甲乙类传染病保险金`,
          riskAmountDesc:this.countData.SWCJ/10*2 + 100000
        }] 
      } else {
        arr =[{
          riskCode: "PL1800143", //意外伤害医疗
          amount: this.countData.YLFY,
          dutyCode: "CV02197",
          riskInfoName: "hospitalizationByAccident",
          premiumAmt:0,
          riskName:`意外伤害医疗费用（社保范围内100元免赔100%赔付）`,
          riskAmountDesc:this.countData.YLFY
        },
        {
          riskCode: "PL1800143", //意外伤害住院津贴
          amount: this.countData.ZYJT * 180,
          dutyCode: "CV01931",
          riskInfoName: "allowanceByAccident",
          premiumAmt:0,
          riskName:`意外伤害住院津贴`,
          riskAmountDesc:this.countData.ZYJT+'元/天'
        }] 
      }
      return [...infos,...arr];
    },
    // 投保人名称限制
    nameFilter() {
      if (this.countData.name) {
        const nameFilter = /家具|木材|五金|金属|建筑|工程|实业|劳务|剪切|车床/
        if (nameFilter.test(this.countData.name)) {
          this.countData.KZSC = 0;
          console.log(true);
          return true;
        } else {
          console.log(false);
          return false;
        }
      } else {
          console.log(false);
        return false;
      }
    },
  },
  watch: {
    "countData.YLFY"(val) {
      if (!val) {
        this.countData.ZFYF = 0;
      }
    },
    // "countData.HYLX"(val, oldval) {
    //   if (val == 1) { // 建筑行业
    //     alert('建筑行业')
    //     this.countData.KZSC = 0
    //   }else{
    //     alert('其他行业')
    //     this.countData.SFSGa = 2;
    //   }
    // },
  },
  props: ["disabledAll"],
  created() {
    const {  p, planCode } = this.$route.query;
    this.productCode = p;
    if (p) {
      this.leibie = parseFloat(planCode.split("_")[1]).toString() + "类";
    } else {
      this.leibie = "1类";
    }
    this.plan = planCode;
    this.countPremiumSum("init");
  },
  mounted() {
    this.$bus.$on("busRiskInfos", (data) => {
      let obj = this.$lodash.cloneDeep(this.countData);
      console.log(data);
      let hasZFYF = false
      data.riskInfos.forEach((e) => {
        if (e.riskCode == "PL1800143" && e.dutyCode == "CV63001")
          obj.SWCJ = e.amount;
        if (e.riskCode == "PL1800143" && e.dutyCode == "CV02197")
          obj.YLFY = e.amount;
        if (e.riskCode == "PL1800181" && e.dutyCode == "CVJA017") //b 款
          obj.YLFY = e.amount;
        if (e.riskCode == "PL180J136" && e.dutyCode == "CVJA046")
          hasZFYF = e.amount
        if (e.riskCode == "PL1800143" && e.dutyCode == "CV01931")
          obj.ZYJT = e.amount/180;
        if (e.riskCode == "selTag99" && e.dutyCode == "selTag99")
          obj.KZSC = e.amount;
        if (e.riskCode == "PL1800144" && e.dutyCode == "CV01659")
          obj.YCXSCa = e.amount;
        if (e.riskCode == "PL1800144" && e.dutyCode == "CV01660")
          obj.SHHLa = e.amount;
        if (e.riskCode == "PL1800144" && e.dutyCode == "CV01661")
          obj.KYLCYW = e.amount;
        if (e.riskCode == "PL1800144" && e.dutyCode == "CV01662")
          obj.KYQCYW = e.amount;
        if (e.riskCode == "PL1800276" && e.dutyCode == "CV01360")
          obj.JCYW = e.amount;
        if (e.riskCode == "PL180J105" && e.dutyCode == "CVJB009")
          obj.WGFY = e.amount;
        if (e.riskCode == "PL1800192" && e.dutyCode == "CVJD006")//b 款
          obj.ZYJT = e.amount/180;
      });
      if(hasZFYF) {
        obj.ZFYF = hasZFYF/obj.YLFY;
      }
      console.log(obj);
      this.countData = { ...obj };
      this.countData.SFSGa = Number(data.salPolicyExt.isworkheightinvolved)||2
      this.countData.HYLX = Number(data.salPolicyExt.architecture)||0
      this.countData.name = data.salPolicyHolder.name
      this.form.setFieldsValue({
        countData: this.countData
      })
      this.guapre = Number(data.salPolicy.bracket)||3
      this.changeData()
    });
  },
  beforeDestroy() {
    this.$bus.$off("busRiskInfos");
  },
  methods: {
      // 去投保
      goplicy() {
        this.$store.commit('setAgreement', true)
      },
    //初始化扩展社保范围外医疗费用
    reactdata() {
      if (this.countData.YLFY == 0) {
        this.countData.ZFYF = 0;
      }
      if (
        this.occupationNumberList[3].personNum ||
        this.occupationNumberList[4].personNum
      ) {
        this.countData.ZFYF = 0;
      }
    },

    // 改变试算的数据
    changeData(value, param) {
      console.log(value, param);
      if (param=='HYLX') {
        if (value == 1) { // 建筑行业
          this.countData.KZSC = 0
        }else{
          this.countData.SFSGa = 2;
        }
      }
      // this.reactdata();
      this.countData[param] = value;
      this.data = {
        architecture: this.countData.HYLX.toString(), //是否是建筑行业，1建筑行业，0其他行业
        // riskInfos: this.riskInfos.filter((item) => item.amount > 0),
        riskInfos: this.riskInfos, //险种信息
        salPolicy: {
          productCode: this.productCode, //产品code
          bracket: this.countData.BZQJa.toString(), //保费期限
          planCode: this.plan,
        },
        salPolicyExt:{
          isworkheightinvolved:this.countData.SFSGa.toString(),
          architecture:this.countData.HYLX.toString(),
          occEmpVersion: this.fileCodeContent.id,
        },
        salPolicyHolder: {
          addfifty: "1", // 测算类型
          name: this.countData.name,
          stature: this.countData.SFSGa.toString(), //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: this.occupationNumberList.filter(
          (item) => item.personNum > 0
        ), //人数
        // premiumBaseDtoList: this.occupationNumberList, //人数
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      delete arrData["premiumBaseDtoList"]; //投保职业人数是不参与下面的计算的
      if (param != "TBZYa") {
        console.log(arrData, "开始传数据");
        this.$bus.$emit("onRiskInfos", arrData);
      }
      // if (param=='HYLX'&&value=='1') {
      //   this.$bus.$emit("clearData");
      // }
    },
    //测算的总价格
    cesuannum(data) {
      var a = {};
      var resultnum = 0;
      this.data.premiumBaseDtoList.forEach((e) => {
        a[e.occupationKind] = e.personNum;
      });
      for (const key in a) {
        console.log(key);
        resultnum += a[key] * data[key];
        // resultnum += a[key] * (this.countData.SFSGa==1?data['涉高']:data[key]);
      }
      console.log(resultnum, "总保费");
      return resultnum.toFixed(2);
    },
    //保费试算
    countPremiumSum(type) {
      console.log(type);
      this.data.salPolicyHolder.addfifty = "1";
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log(this.data, "改变试算要提交的数据");
          if (type != "init") {
            if (this.totalNumber < 3) {
              this.premiumSum = 0;
              this.$message.warning("投保人数最少为3人");
              return;
            }
            let UNname1 = "天津";
            if (this.data.salPolicyHolder.name.indexOf(UNname1) > -1) {
              this.$message.warning("本产品不承保天津及所辖地区的企业。");
              return;
            }
            debugger
            const UNname2 = /拆|拆房|房屋|疏浚|脚手架|危险品|幕墙|电梯|铁塔|珠宝|黄金|贵金属|劳务|劳联|产联|人力资源|人力|人资|企业咨询|人才服务|人力介绍/
            if (UNname2.test(this.data.salPolicyHolder.name)) {
              this.$message.warning(
                "投保人名称中含以下关键字的企业团体拒保：拆、拆房、房屋、疏浚、脚手架、危险品、幕墙、电梯、铁塔、珠宝、黄金、贵金属、劳务、劳联、产联、人力资源、人力、人资、企业咨询、人才服务、人力介绍，不在方案承保范围。"
              );
              return;
            }

            let UNname3 = /珠宝|黄金|贵金属/;
            if (UNname3.test(this.data.salPolicyHolder.name)) {
              this.$message.warning(
                "禁止承保投保人或被保险人企业名称包含“珠宝，黄金，贵金属”的企业。"
              );
              return;
            }
            let UNname4 = ['家具','木材','红木','五金','金属','建筑','工程','实业','劳务','剪切','车床'];
            let UNname4BOl = false
            let KZSC = this.riskInfos.filter(item => item.riskCode == 'selTag99'&&item.amount!=0).length
            UNname4.forEach(element=>{
              if(this.data.salPolicyHolder.name.indexOf(element) > -1){
                UNname4BOl = true
              }
            })
            if (UNname4BOl && KZSC>0) {
              this.$message.warning(
                "承保投保人或被保险人企业名称包含“家具 木材 红木 五金 金属 建筑 工程 实业 劳务 剪切 车床“不能附加工伤标准。"
              );
              return;
            }
          }
          if (type == "init") {
            this.data.riskInfos = this.$lodash.cloneDeep(this.riskInfos);
            this.data.salPolicy.productCode = this.productCode;
            this.data.salPolicy.planCode = this.plan;
            this.data.salPolicy.creator = '1';
            this.data.salPolicy.bracket = '3';
            this.data.salPolicyHolder.name = this.countData.name;
            return
          }

          this.$api.calPremiumEmployer(this.data).then((res) => {
            console.log(res, "测试保费接口返回");
            if (res.data.success) {
              let data = res.data.content;
              this.premiumSum = this.cesuannum(data);
              console.log(data);
              console.log(this.premiumSum, "计算出来的总保费");
              // this.$bus.$emit("CScontent", data);
            } else {
              this.$message.error(res.data.returnMsg + "错误");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .policy {
    display: none;
  }

.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}
.pre-box {
  margin-top: 15px;
}
.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}
.risk_ {
  width: 60%;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}
.flex_ {
  display: flex;
  flex-wrap: wrap;
}
.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}
.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
.waring-color{
  font-size: 12px;
  color: #e6a23c;
}
.gsdiposition{
  width: 300px;
}
.gsdc-icon{
  margin: 3px 3px 0;
}
</style>